/*
 Initial state and properties
 */
 export const initialState = {
    mode:"POST",
    operadoresIdSelected:0,
    defaultDataOperadores:{}
 }
 /*
  Action types
  */
 export const SET_MODE = 'SET_MODE'
 export const SET_OPERADORES_ID = 'SET_OPERADORES_ID'
 export const SET_DEFAULT_DATA = 'SET_DEFAULT_DATA'
 /*
  Arrow function for change state
  */
 export const setMode = (payload) => ({
   type: SET_MODE,
   payload,
 });
 export const setOperadoresId = (payload) => ({
  type: SET_OPERADORES_ID,
  payload,
})
export const setDefaultDataOperadores = (payload) => ({
  type: SET_DEFAULT_DATA,
  payload,
})
 /*
  Reducer to describe how the state changed
  */
 export default function Reducer(state = initialState, { type, payload }) {
   switch (type) {
     case SET_MODE:
       return {
         ...state,
         mode: payload,
       }
       case SET_OPERADORES_ID:
        return {
          ...state,
          operadoresIdSelected: payload,
        }
        case SET_DEFAULT_DATA:
          return {
            ...state,
            defaultDataOperadores: payload,
          }
     default:
       return state
   }
 }
 